module.exports = "/_next/static/resources/secret-messages-bfaaa590b7f7ae16711ffeb14aa995b9.mp4";